const colors = {
  WHITE: '#FFF',
  WHITE_SHADE2: '#f0f0f0',
  BLACK: '#000',
  BLACK_SHADE1: '#222222',
  LIGHT_GREY: '#D9D9D9',
  LIGHT_GREY_SHADE8: '#C4C4C4',
  BUTTON_PRIMARY_COLOR: '#9747FF',
  BUTTON_SHADOW_COLOR: '#713cc5',
  PRIMARY_SHADOW_COLOR: '#713DC4',
  BUBBLE_COLOR: '#FFFFFF',
  GREEN: '#14AE5C',
  YELLOW: '#FFD700',
  GREY_BORDER: '#ccc',
  TRANSPARENT: 'transparent',
  BG_GREY: 'rgba(0,0,0,0.3)',
};

export default colors;
